const ReadableDateString = (d: any, render_mode?: "full" | "half") => {
	const week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	const weekShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	const month = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	const date = new Date(d);
	const mode: "full" | "half" = render_mode || "full";
	if (mode === "full") {
		return (
			week[date.getDay()] +
			", " +
			month[date.getMonth()] +
			"  " +
			date.getDate() +
			(date.getDate() == 1 ? "st" : date.getDate() == 2 ? "nd" : date.getDate() == 3 ? "rd" : "th") +
			" " +
			date.getFullYear() +
			" at " +
			(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
			":" +
			(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
			":" +
			(date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()) +
			" (IST)"
		);
	} else {
		return (
			weekShort[date.getDay()] +
			", " +
			month[date.getMonth()] +
			"  " +
			date.getDate() +
			(date.getDate() == 1 ? "" : date.getDate() == 2 ? "" : date.getDate() == 3 ? "" : "") +
			" " +
			date.getFullYear()
		);
	}
};
export default ReadableDateString;
